import axios from '@axios'

/**
 * Authenticated (staff) side of the General Consent flow:
 * generate / inspect / revoke the shareable patient signing link.
 */
export default {
  /**
   * Generate a fresh consent link for a registration.
   * @param {number|string} pendaftaranId
   * @param {number|string} idPegawai - chosen Petugas (employee) id
   * @param {string} signerType - 'patient' or 'representative'
   */
  generate: (pendaftaranId, idPegawai, signerType) =>
    axios.post(`/pendaftaran/${pendaftaranId}/general-consent`, {
      id_pegawai: idPegawai,
      signer_type: signerType,
    }),

  /**
   * Get the latest consent (status, link, pdf) for a registration.
   * @param {number|string} pendaftaranId
   */
  getStatus: (pendaftaranId) => axios.get(`/pendaftaran/${pendaftaranId}/general-consent`),

  /**
   * Revoke a pending consent link.
   * @param {string} consentId
   */
  revoke: (consentId) => axios.delete(`/general-consent/${consentId}`),

  /**
   * Reset a signed consent (delete its PDF + revoke) so the patient can re-sign.
   * @param {number|string} pendaftaranId
   */
  reset: (pendaftaranId) => axios.post(`/pendaftaran/${pendaftaranId}/general-consent/reset`),
}
